var _mask, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedSemiCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 492,
    viewBox: "0 0 1440 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_176_2366",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 662C1440 487.191 1364.8 319.477 1230.81 195.457C1096.82 71.4374 914.918 1.17936 724.797 0.014693C534.676 -1.14998 351.772 66.8733 215.996 189.241C80.2211 311.608 2.59728 478.385 0.0639203 653.179L720 662H1440Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 662C1440 487.191 1364.8 319.477 1230.81 195.457C1096.82 71.4374 914.918 1.17936 724.797 0.014693C534.676 -1.14998 351.772 66.8733 215.996 189.241C80.2211 311.608 2.59728 478.385 0.0639203 653.179L720 662H1440Z",
    fill: "url(#paint0_linear_176_2366)",
    stroke: "#BB1B1B",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_176_2366)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_176_2366",
    x1: 720.57,
    y1: 231.729,
    x2: 720.57,
    y2: -149.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626356,
    stopColor: "#BB1B1B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FA",
    stopOpacity: 0.38
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedSemiCircle);
export default __webpack_public_path__ + "static/media/red-semi-circle.eaec84321a667924e693ec1b41e3d646.svg";
export { ForwardRef as ReactComponent };